import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import { T } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'
import './index.scss'

export default function LinkToast({ toast, inline = false }) {
  function handleLinkCallback() {
    toast?.linkCallback?.()
  }

  return (
    <div
      className={classNames('Toast-LinkToast', {
        inline: !!inline,
      })}
    >
      <p>{toast.message}</p>

      <div className="toast-messageLink">
        <Link className="toast-link" to={toast.link} onClick={handleLinkCallback}>
          {toast?.linkLabel ? (
            toast.linkLabel
          ) : (
            <T keyName={TOLGEE_GLOBALS.seeNow.key}>{TOLGEE_GLOBALS.seeNow.defaultValue}</T>
          )}
        </Link>
      </div>
    </div>
  )
}
